import React, { useState, useEffect } from 'react'
import axios from 'axios'
import './NavJuridico.css'
import brasao from '../../assets/crefito.png'

const NavJuridico = (props) => {

    function logout() {
        localStorage.clear()

        window.location = "/juridico"
    }

    if (window.matchMedia("(min-width:600px)").matches) {
        return (
            <div className="nav">
                <a href="/juridico"><img src={brasao} alt="Brasil" className='brasaoNav' /></a>
                <div className="dropdown">
                    <span className='drop dropPed'>Processos<i className="bi bi-caret-down-fill iconeDown"></i></span>
                    <div className="caixa1">
                        <div className="caixao">
                            <div className='mt-2'>
                                <span><i className="iNav bi bi-file-earmark-plus"></i><a href="/juridico/novoProcesso">Criar Processo</a></span>
                            </div>
                            <div className='mt-2'>
                                <span><i className="iNav bi bi-search"></i><a href="/juridico/buscaProcesso">Pesquisar Processo</a></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="dropdown">
                    <span className='drop dropSMembro'>Suporte<i className="bi bi-caret-down-fill iconeDown"></i></span>
                    <div className="caixaSMembro">
                        <div className="caixao">
                            {renderSuporte()}
                        </div>
                    </div>
                </div>
                <div className="dropdown">
                    <a href="/juridico/senha" className='drop dropSPed'>Senha</a>
                </div>
                <a onClick={e => logout()}>
                    <span className='drop drop7'><i className="bi bi-box-arrow-in-right"></i>Sair</span>
                </a>
            </div>
        )
    } else {
        return (
            <div className="nav">
                <div className="dropdown">
                    <span className='menuPosition'><i className="bi bi-menu-up iMenu"></i></span>
                    <div className="caixaMobile">
                        <div className="caixaoMobile">
                            <div>
                                <div className="dropMobile">
                                    <span>Processos<i className="bi bi-caret-down-fill iconeDown"></i></span>
                                    <div className="dropExtend">
                                        <div className='mt-3'>
                                            <span><i className="bi bi-file-earmark-plus"></i><a href="/juridico/novoProcesso">Criar Processo</a></span>
                                        </div>
                                        <div className='mt-3'>
                                            <span><i className="bi bi-search"></i><a href="/juridico/buscaProcesso">Pesquisar Processo</a></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='mt-3'>
                                <div className="dropMobile">
                                    <span>Suporte<i className="bi bi-caret-down-fill iconeDown"></i></span>
                                    <div className="dropExtend">
                                        {renderSuporte()}
                                    </div>
                                </div>
                            </div>
                            <div className='mt-3'>
                                <a href="/juridico/senha" className="linkMobile">Senha</a>
                            </div>
                        </div>
                    </div>
                </div>
                <a href="/juridico" className='brasaoHorizontal'>
                    <div className="brasaoVertical">
                        <img src={brasao} alt="Brasil" className='brasaoNav' />
                    </div>
                </a>
                <div className="sairMobile">
                    <a onClick={e => logout()}>
                        <span><i className="bi bi-box-arrow-in-right"></i> Sair</span>
                    </a>
                </div>
            </div>
        )
    }

    function renderSuporte() {
        if (localStorage.tipoE == "interno") {
            return (
                <div className='mt-2'>
                    <span><i className="iNav bi bi-envelope"></i><a href="/suporteInterno">Chamados</a></span>
                </div>
            )
        } else {
            return (
                <React.Fragment>
                    <div className='mt-2'>
                        <span><i className="iNav bi bi-envelope-plus"></i><a href="/juridico/novoChamado">Novo Chamado</a></span>
                    </div>
                    <div className='mt-2'>
                        <span><i className="iNav bi bi-envelope"></i><a href="/juridico/meusChamados">Meus Chamados</a></span>
                    </div>
                </React.Fragment>
            )
        }
    }
}
export default NavJuridico